import { render, staticRenderFns } from "./DeniedUsers.vue?vue&type=template&id=0f858ba6"
import script from "./DeniedUsers.vue?vue&type=script&lang=js"
export * from "./DeniedUsers.vue?vue&type=script&lang=js"
import style0 from "./DeniedUsers.vue?vue&type=style&index=0&id=0f858ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports